// @ts-nocheck
import type { UseFormReturn } from "react-hook-form";
import { FormProvider as RHFForm } from "react-hook-form";

// ----------------------------------------------------------------------

export type FormProps = {
  onSubmit?: () => void;
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  id?: string;
  className?: string;
};

export function Form({
  children,
  onSubmit,
  methods,
  id,
  className,
}: FormProps) {
  return (
    <RHFForm {...methods}>
      <form
        id={id}
        onSubmit={onSubmit}
        noValidate
        autoComplete="off"
        className={className}
      >
        {children}
      </form>
    </RHFForm>
  );
}
